import { useStytchOrganization } from '@stytch/react/b2b'

import { useCurrentUser } from 'modules/common/hooks'

import { ConsentScreen } from '../components'
import { useOAuthConsent } from '../hooks/useOAuthConsent'

/**
 * Fully custom OAuth IdP consent screen. The `useOAuthConsent` hook drives the
 * headless Stytch idp flow (parse request → show consent → submit decision →
 * redirect) and this page renders the result with our own styling via
 * <ConsentScreen />. Mounted in the authenticated DashboardApp router, outside
 * <Layout /> so it has no dashboard nav/sidebar chrome.
 *
 * To preview locally, log in first then visit (port required, params must match
 * an OAuth client configured in the Stytch dashboard):
 *   https://local.seqhq.io:3001/oauth/authorize?client_id=<real-client-id>&redirect_uri=<registered-redirect-uri>&response_type=code&scope=openid
 */
export const AuthorizePage = () => {
  const { status, redirectUri, resolvedRedirectUri, approve, deny } =
    useOAuthConsent()

  const { email } = useCurrentUser()
  const { organization } = useStytchOrganization()

  return (
    <ConsentScreen
      status={status}
      redirectUri={redirectUri}
      resolvedRedirectUri={resolvedRedirectUri}
      accountEmail={email}
      accountWorkspace={organization?.organization_name}
      onApprove={approve}
      onDeny={deny}
    />
  )
}

export default AuthorizePage
